require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-the-design-chaser-melfort-townhouses.json") })
        }
      }, "path---journal-the-design-chaser-melfort-townhouses");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-the-design-chaser-melfort-townhouses!./.cache/json/journal-the-design-chaser-melfort-townhouses.json
// module id = 537
// module chunks = 231608221292675